export default __webpack_public_path__ + "static/media/group-option-glasses-selected.042ab424.svg";